import { useEffect, useState } from 'react';
import * as React from 'react';
import {IMAGE_URLS} from "../../utils/imageUtils";
import Map from "../Map/Map";
import {LocationMapProps} from "./locationMapTypes";
import {MapTypeId, MarkerProps, Position} from "../Map/mapTypes";

const { MARKER_ICON } = IMAGE_URLS;

const LocationMap = (props: LocationMapProps) => {
    const [mapCenter, setMapCenter] = useState<Position>({lat: props.locations[0].lat, lng: props.locations[0].lng});
    const [markers, setMarkers] = useState<MarkerProps[]>([]);

    const updateMarkers = () => {
        const items = props.locations.map((i) => {

            const icon = MARKER_ICON;
            const iconActive = MARKER_ICON;

            return {
                id: i.id,
                title: i.name,
                lat: i.lat,
                lng: i.lng,
                icon,
                iconActive,
            };
        });

        setMarkers(items);
    };

    useEffect(() => {
        updateMarkers();
    }, [props.locations]);

    return (
        <Map
            center={mapCenter}
            markers={markers}
            useClusters={false}
            initialZoom={13}
            onSelectMarker={undefined}
            mapTypeId={ MapTypeId.HYBRID }
        />
    );
};

export default LocationMap;
